import {
  type EditInSeasonAggregationResponse,
  type GetInSeasonAggregationsListResponse,
  type InSeasonAggregationListItem,
} from '../types';

import { mapRowDimensionToIdentifier } from './map-row-dimension-to-identifier';
import { getDimensions } from './transform-dimensions';

export const transformEditInSeasonAggregationResponse = ({
  items,
}: EditInSeasonAggregationResponse) => {
  return {
    items: items.map(transformInSeasonAggregationItem),
  };
};

export const transformInSeasonAggregationResponse = ({
  page_info,
  items,
}: GetInSeasonAggregationsListResponse) => {
  return {
    page_info,
    items: items.map(transformInSeasonAggregationItem),
  };
};

const transformInSeasonAggregationItem = (
  item: InSeasonAggregationListItem,
) => {
  const rowIdentifiers = item.dimensions.map((dimension) =>
    mapRowDimensionToIdentifier(dimension),
  );
  const rowIdentifiersString = JSON.stringify(rowIdentifiers);
  return {
    id: rowIdentifiersString,
    is_fetching_assortment_status: false,
    is_fetching_assortment_dates: false,
    is_fetching_initial_allocation: false,
    ...item,
    dimensions: getDimensions(item.dimensions),
  };
};
